export enum ClipType {
  CLIP = "Clip",
  LINE = "Line",
  EDIT = "Edit",
}